// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca0058cd","239":"d2046ce2","453":"bc9e4357","455":"e41966d5"}[chunkId] + ".chunk.js";
};